import { createSignal } from "solid-js";
export default function MobileBackButton(props: { onClick: () => void }) {
  const [show, setShow] = createSignal(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div class="relative">
      <div
        class="w-12 h-12 m-5 cursor-highlight-pointer bg-transparent rounded-full animate__animated animate__fadeInUp backdrop-filter[blur(0.76px)] z-50"
        onClick={() => props.onClick()}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Doodle border start */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="50"
          height="50"
          class="overflow-hidden absolute"
          style={{
            transition: "transform 0.2s ease",
            transform: show() ? "rotate(90deg)" : "rotate(0)",
          }}
        >
          <path
            stroke-width="5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.27 8.36a11.87834 11.87834 0 0 0-2.4892-4.36468C19.6494 2.73454 18.2614 1.73031 16.71 1.05a12.259511 12.259511 0 0 0-2.6-.819999C11.1643-.126095 8.18833.583309 5.72002 2.23c-1.96265 1.1391-3.54809 2.82885-4.56 4.86a14.370021 14.370021 0 0 0-.999999 3.68 16.000097 16.000097 0 0 0-.11 3.81c.164159 1.4252.653397 2.7937 1.429999 4 .75755 1.1732 1.69192 2.2223 2.77 3.11 1.22765 1.0228 2.69835 1.7117 4.27 2 1.52018.2799 3.07258.3405 4.60998.18 2.3042-.1894 4.5328-.9118 6.51-2.11 1.3432-.836 2.4297-2.0263 3.14-3.44 1.4437-3.1321 1.6193-6.7013.49-9.96Zm-1.43 9.43c-.8207 1.5301-2.1204 2.749-3.7 3.47-1.596.7759-3.3216 1.2505-5.09 1.4-1.4304.147-2.8744.0931-4.28998-.16a9.929548 9.929548 0 0 1-3.63424-1.602c-1.09117-.7732-2.0149-1.759-2.71576-2.898a8.409989 8.409989 0 0 1-1.33-3.5 14.270106 14.270106 0 0 1 0-3.57 13.389887 13.389887 0 0 1 .92-3.5c.89541-1.8939 2.32372-3.48555 4.11-4.58C7.86591 1.66334 9.89065.934566 12 .730001a.329928.329928 0 0 0 .14.115808c.0565.024749.1189.03313.18.024192a5.40995 5.40995 0 0 1 1.68.06A11.600378 11.600378 0 0 1 16.43 1.75a9.150037 9.150037 0 0 1 1.9 1.1c1.8879 1.47294 3.283 3.48537 4 5.77 1.0309 3.0047.8552 6.2922-.49 9.17Z"
            class={`fill-current ${
              show() ? "text-primary-100" : "text-neutral-50"
            }`}
          />
        </svg>
        {/* Doodle border end */}
        <div class="absolute top-[40%] h-12 w-12 z-10">
          {/* XMarkIcon start */}
          {/* XMarkIcon start */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class={`transition-transform duration-200 ease-in-out transform ${show() ? "rotate-90" : "rotate-0"}`}
            width="50"
            height="20"
          >
            <g clip-path="url(#a)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.18 6.24001c.3197-.46967.5943-.96856.82-1.49a1.001203 1.001203 0 0 0-.057-.40306 1.001273 1.001273 0 0 0-.213-.34694 16.48013 16.48013 0 0 0-2.73-2.31 4.66046 4.66046 0 0 0-1.47-.769996.639825.639825 0 0 0-.3224.027905.63959.63959 0 0 0-.2676.182091c-.31.36-1 .94-1.74 1.65-.25.24-.51.5-.75.78-1.45 1.57-2.96 3.44-3.68 4.26-1.52-1.58-4.72001-5-6.31001-6.3a2.770097 2.770097 0 0 0-1.09-.599996A.709967.709967 0 0 0 5.092.906042a.710093.710093 0 0 0-.26201.093968c-.09.11-3.829997 2.67-4.629997 4.11a1.210017 1.210017 0 0 0-.193289.55744 1.209953 1.209953 0 0 0 .093288.58256 3.569849 3.569849 0 0 0 .66.82 9.87855 9.87855 0 0 0 .999998.91c.25.19.91.78 1.68 1.5 1.25 1.12999 2.76 2.51999 3.5 3.26999-1 .86-3.33 2.88-4.71 4.26-.41664.3876-.78893.8202-1.11 1.29a.860149.860149 0 0 0-.129998.43c.129168.4291.370868.8159.699998 1.12a39.391046 39.391046 0 0 0 2.91 2.67c.15.13.41.69.91.55.1945-.1007.37586-.225.54-.37.28-.2 1.87-1.51 3.52-2.94C10.73 18.76 11.91 17.7 12.69 16.93l.41.34c1.68 1.39 5.85 4.95 6 5.23.0201.0403.0481.0761.0822.1055.0341.0294.0737.0517.1165.0656.0427.014.0879.0193.1327.0157a.338618.338618 0 0 0 .1286-.0368l.33-.2c.59-.4 1.86-1.36 2.61-2 .029-.0288.0521-.0631.0678-.1008.0157-.0378.0238-.0783.0238-.1192 0-.0409-.0081-.0814-.0238-.1191-.0157-.0378-.0388-.0721-.0678-.1009a.301112.301112 0 0 0-.0983-.0671c-.0369-.0156-.0766-.0237-.1167-.0237s-.0798.0081-.1167.0237-.0704.0384-.0983.0671c-.74.62-2 1.55-2.58 1.93h-.06c-.93-.94-4.35-4-5.84-5.28l-.59-.53c-.0859-.0665-.1914-.1026-.3-.1026s-.2141.0361-.3.1026c-.77.76-2.09 1.9-3.38001 3-1.63 1.37-3.2 2.63-3.48 2.82l-.1.08-.19-.2c-.33-.29-1.08-.95-1.78-1.63-.4838-.4265-.92888-.895-1.33-1.4.04424-.0951.09784-.1855.16-.27.63128-.6664 1.29897-1.2974 2-1.89 1.7-1.64 3.87-3.43 3.87-3.43a.56061.56061 0 0 0 .14568-.1882.56025.56025 0 0 0 .05432-.2318c.00527-.0798-.00725-.1597-.03665-.2341a.539438.539438 0 0 0-.13335-.1959s-2.2-2.17-3.92-3.73999c-.82-.76-1.51-1.39-1.78-1.62a7.639656 7.639656 0 0 1-.9-.79c-.59-.59-.49-.44-.13-.86.23-.27.5-.51.64-.67a25.380387 25.380387 0 0 1 3.18-2.52c.14198.09254.27884.19269.41.3 1.74 1.39 5.41001 5.32 6.68001 6.54.054.05534.1186.09931.1898.12933a.580477.580477 0 0 0 .2252.04549c.0773 0 .1539-.01547.2252-.04549.0712-.03002.1358-.07399.1898-.12933.07-.07.21-.23.4-.46.71-.85 2.21-2.7 3.61-4.29l2.31-2.31h.09a15.060241 15.060241 0 0 1 3 2.22c.1454.13831.2823.28524.41.44-.184.37901-.391.74636-.62 1.1-.2688.4162-.5697.81074-.9 1.18L17.4 11.63c-.0692.0828-.1071.1872-.1071.295 0 .1079.0379.2123.1071.295.1681.2327.3483.4564.54.67 1.15 1.33 3.77 4.19 4.79 5.51.18.23.25.51.34.51.012.0833.0506.1605.11.22.0326.0333.0715.0597.1144.0777.0429.0181.089.0274.1356.0274s.0927-.0093.1356-.0274c.0429-.018.0818-.0444.1144-.0777.0581-.0837.0892-.1831.0892-.285 0-.1019-.0311-.2013-.0892-.285-.3006-.4765-.6348-.931-1-1.36-1.26-1.53-3.34-3.86-4.23-4.93L18.2 12l4-4.47999c.3563-.40311.6838-.83083.98-1.28Z"
                class={`fill-current ${
                  show() ? "text-primary-100" : "text-neutral-50"
                }`}
              />
            </g>
            <defs>
              <clipPath id="a">
                <path
                  class={`fill-current ${
                    show() ? "text-neutral-50" : "text-neutral-50"
                  }`}
                  d="M0 0h24v24H0z"
                />
              </clipPath>
            </defs>
          </svg>
          {/* XMarkIcon end */}
        </div>
      </div>
    </div>
  );
}
